var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPeople(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 92.836,
    height: 68.079,
    viewBox: "0 0 92.836 68.079",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "people",
    transform: "translate(-1.5 -7.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14240",
    "data-name": "Path 14240",
    d: "M39.7,41.539a14.852,14.852,0,0,1-10.831-5,19.322,19.322,0,0,1-5.029-11.8,16.149,16.149,0,0,1,4.089-12.332A15.782,15.782,0,0,1,39.7,7.5a15.8,15.8,0,0,1,11.74,4.936,16.116,16.116,0,0,1,4.112,12.306,19.376,19.376,0,0,1-5.029,11.8A14.814,14.814,0,0,1,39.7,41.539ZM52.461,24.52Z",
    transform: "translate(23.693 0)",
    fill: "#f7c04b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14241",
    "data-name": "Path 14241",
    d: "M72.943,54.85H21.952A5.359,5.359,0,0,1,17.7,52.787,5.845,5.845,0,0,1,16.679,47.8,25.489,25.489,0,0,1,28.346,32.118,36.686,36.686,0,0,1,47.446,27a36.351,36.351,0,0,1,19.091,5.038A25.347,25.347,0,0,1,78.215,47.81,5.854,5.854,0,0,1,77.186,52.8,5.353,5.353,0,0,1,72.943,54.85Z",
    transform: "translate(15.943 20.728)",
    fill: "#f7c04b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14242",
    "data-name": "Path 14242",
    d: "M20.677,39.124c-6.806,0-12.79-6.328-13.345-14.105a13.636,13.636,0,0,1,3.481-10.37A13.278,13.278,0,0,1,20.677,10.5a13.232,13.232,0,0,1,9.85,4.172,13.53,13.53,0,0,1,3.481,10.351C33.453,32.8,27.471,39.124,20.677,39.124Z",
    transform: "translate(6.159 3.189)",
    fill: "#f7c04b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14243",
    "data-name": "Path 14243",
    d: "M39.535,28.609a29.353,29.353,0,0,0-12.7-2.495A29.916,29.916,0,0,0,11.255,30.3,20.983,20.983,0,0,0,1.662,43.2a5.3,5.3,0,0,0,.926,4.518A4.9,4.9,0,0,0,6.474,49.6H27.942a1.547,1.547,0,0,0,1.522-1.27c.021-.122.048-.244.079-.364A28.014,28.014,0,0,1,40.705,31.758a1.547,1.547,0,0,0-.122-2.59c-.3-.178-.652-.366-1.048-.559Z",
    transform: "translate(0 19.787)",
    fill: "#f7c04b"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPeople);
export default __webpack_public_path__ + "static/media/People.08c73d20e8deff86a382a197a79db4cc.svg";
export { ForwardRef as ReactComponent };